<agr-summary-card-horizontal [title]="title()" [actions]="actions()" [items]="items()">
</agr-summary-card-horizontal>
